import "@/firebase/init";
import {
  getMessaging,
  getToken,
  isSupported,
  onMessage,
} from "firebase/messaging";
import { $notify } from "@/toaster/ToasterPlugin";
import axios from "axios";
import handlers from "@/firebase/handler";

let messaging;

function init() {
  console.info("Firebase started");
  messaging = getMessaging();
  onMessage(messaging, (payload) => {
    console.info("Message received. web ", payload);
    if (payload.data.type === "account_approved") {
      const event = new CustomEvent("firebase:account_approved", {
        detail: payload,
      });
      document.dispatchEvent(event);
    }

    let handler = handlers[payload.data.type];
    $notify.success(
      payload.notification.body,
      handler ? handler(payload.data) : undefined
    );
  });
}

async function subscribe() {
  try {
    const currentToken = await getToken(messaging, {
      serviceWorkerRegistration: await navigator.serviceWorker.register(
        process.env.VUE_APP_FIREBASER_SW_PREFIX + "/firebase-messaging-sw.js"
      ),
      vapidKey:
        "BBl-VGIL0ji9XHDXbR9-fBusz2_VrlNIMRgGaKeAioytSTtTGiSc_Ik2WyK0LVuprowFyJszLBrQWETNSFzFeds",
    });
    if (!currentToken) {
      console.error(
        "No registration token available. Request permission to generate one."
      );
    }
    if (localStorage.fcm_token === currentToken) {
      return;
    }
    unsubscribe();
    console.log({ currentToken });
    await axios.post("/notifications/subscribe", {
      token: currentToken,
      type: "web",
      lang: localStorage.lang ?? "ar",
    });
    localStorage.setItem("fcm_token", currentToken);
  } catch (e) {
    console.error("An error occurred while retrieving token. ", e);
  }
}

export async function checkPermission() {
  let notificationSupported = await isSupported();
  if (!("Notification" in window) || !notificationSupported) {
    console.warn("This browser does not support desktop notification");
    return;
  }

  if (Notification.permission === "denied") {
    console.warn("User denied the notification");
    return;
  }

  if (needToAskForPermission()) {
    return;
  }
  init();
  await subscribe();
}

export function needToAskForPermission() {
  return Notification.permission === "default";
}

export async function askForPermission() {
  const permission = await Notification.requestPermission();
  if (permission === "granted") {
    init();
    await subscribe();
  } else {
    console.info("User denied the notification");
  }
}

export async function unsubscribe() {
  if (!localStorage.fcm_token) {
    return;
  }
  await axios
    .post("/notifications/unsubscribe", {
      token: localStorage.fcm_token,
    })
    .catch((e) => console.error("unsubscribe token failed", e));
}
if (localStorage.getItem("userData")) {
  checkPermission().catch(console.error);
}
